import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClientManagementService, Client } from '../../../services/client-management.service';
import { ProxmoxService } from '../../../services/proxmox.service';

@Component({
  selector: 'app-client-registration',
  templateUrl: './client-registration.component.html',
  styleUrls: ['./client-registration.component.scss']
})
export class ClientRegistrationComponent implements OnInit {
  client: Omit<Client, 'id' | 'createdAt'> = {
    name: '',
    email: '',
    company: '',
    status: 'active',
    proxmoxUser: '',
    vms: []
  };
  
  password: string = '';
  confirmPassword: string = '';
  isLoading: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';

  constructor(
    private clientService: ClientManagementService,
    private proxmoxService: ProxmoxService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  onSubmit(): void {
    // Validate passwords match
    if (this.password !== this.confirmPassword) {
      this.errorMessage = 'Passwords do not match.';
      return;
    }
    
    this.isLoading = true;
    this.errorMessage = '';
    this.successMessage = '';
    
    // Create client in the system
    this.clientService.addClient(this.client).subscribe({
      next: (newClient) => {
        this.isLoading = false;
        this.successMessage = `Client "${newClient.name}" registered successfully.`;
        
        // In a real implementation, you would also create the Proxmox user account
        // For now, we'll just show a success message
        console.log('Client registered:', newClient);
        
        // Redirect to admin dashboard after a short delay
        setTimeout(() => {
          this.router.navigate(['/admin-dashboard']);
        }, 2000);
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Error registering client:', error);
        this.errorMessage = 'Error registering client. Please try again.';
      }
    });
  }

  goBack(): void {
    this.router.navigate(['/admin-dashboard']);
  }
}